export default function WinnerBadge({ nominationCount }: { nominationCount?: number }) {
  if (typeof nominationCount !== 'number') return null;
  return (
    <span className="inline-flex items-center gap-1 rounded-full bg-sand px-2 py-1 text-xs text-cocoa shadow-sm">
      🗳️ Selected by community • <strong>{nominationCount}</strong> nomination
      {nominationCount === 1 ? '' : 's'}
    </span>
  );
}
